/**
 * Stub for `useMixpanel` hook from gatsby-plugin-mixpanel.
 * Used to segue out transition from Mixpanel to 1PT.
 */
export const useMixpanel = () => ({
  //eslint-disable-next-line  @typescript-eslint/no-empty-function
  track: (_: string, __?: Record<string, unknown> | undefined) => {}
});
